// Generic snapshot-based undo/redo — replaces v1's 44 action classes.
// Push the PRIOR snapshot before a committed mutation; undo restores it.

export default class UndoStack {
  constructor(limit = 100) {
    this.past = [];
    this.future = [];
    this.limit = limit;
  }

  push(prevSnapshot) {
    this.past.push(prevSnapshot);
    if (this.past.length > this.limit) this.past.shift();
    this.future = [];
  }

  canUndo() { return this.past.length > 0; }
  canRedo() { return this.future.length > 0; }

  undo(currentSnapshot) {
    if (!this.past.length) return null;
    this.future.push(currentSnapshot);
    return this.past.pop();
  }

  redo(currentSnapshot) {
    if (!this.future.length) return null;
    this.past.push(currentSnapshot);
    return this.future.pop();
  }

  clear() { this.past = []; this.future = []; }
}
